import { render, staticRenderFns } from "./collapse-group.component.vue?vue&type=template&id=8532c20e"
import script from "./collapse-group.component.vue?vue&type=script&lang=js"
export * from "./collapse-group.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports